<template>
  <el-dialog :visible.sync="dialogVisible" :before-close="close" class="operate-dialog" :close-on-click-modal='false' :style="{width:operationsLength * 10 +'%',margin:'0 auto', minWidth:'250px'}">
    <p slot="title" class="dialog-title">批量操作</p>
    <div class="operate-cards">
      <template v-if="operations.length">
        <div v-for="(item,index) in operations" :key="index" @click="goLotOperate(item)" :class="['shadow','set-background']" :style="{backgroundImage: 'url(' + (item.background) + ')', backgroundSize:'60%'}">
          <span :class="['iconfont',item.icon]"></span>
          <p>{{item.name}}</p>
        </div>
      </template>
      <p v-else>您没有权限批量操作的权限</p>
    </div>
  </el-dialog>
</template>

<script>
import { hasPermissions } from 'utils/permissions'
import { TaskStatus, LABStatus} from './choice'
// 组件class前缀
const prefixCls = 'pt-lot-operate-choice-dialog'

export default {
  name: 'pt-lot-operate-choice-dialog',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    operationsLength () {
      if (this.operations.length >= 10) {
        return 10
      } else if (this.operations.length > 0 && this.operations.length < 3) {
        return 3
      } else {
        return this.operations.length
      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 关闭的回掉
    handleClose: {
      type: Function
    },
    isTask: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isTask: {
      handler (val, old) {
        this.operations = this.getOperations(val)
      }
    }
  },
  data () {
    return {
      // operations: [],
      visible: this.dialogVisible,
      operations: this.getOperations(this.isTask)
    }
  },
  methods: {
    getOperations (isTask) {
      return this.getHasPermisOpr(isTask ? TaskStatus : LABStatus)
    },
    getHasPermisOpr (data) {
      // let permissons = this.$auth.user().permissions
      // let res = data.filter(item => {
      //   if (Array.isArray(item.permisson)) {
      //     return item.permisson.some((child, index, array) => hasPermissions(permissons, child))
      //   } else {
      //     return hasPermissions(permissons, item.permisson)
      //   }
      // })
      // return res
      return data
    },
    close (val) {
      this.handleClose && this.handleClose()
    },
    goLotOperate (data) {
      const {name } = data
      let route = { name: this.isTask ? 'task-lot-operate' : 'bill-lot-operate', params: { status: name } }
      this.$router.push(route)
    }
  }
}
</script>

<style  lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import "~less/var.less";
.operate-dialog {
  .el-dialog {
    border-radius: 10px;
    padding: 30px;
    width: 100%;
    margin: 0 auto;
  }
  .operate-cards {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    text-align: center;
    justify-content: center;
    .set-background {
      margin-right: 30px;
      &:last-child {
        margin-right: 0;
      }
    }
    .set-background {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width:130PX;
      // flex: 1;
      // padding: 50px 0;
      height: 200PX;
      border-radius: 10px;
      background-position: bottom right;
      background-repeat: no-repeat;
      cursor: pointer;
      // width: .8rem;
      p {
        color: #409eff; //#e9c799;
        font-size: 16px;
        font-weight: bold;
        line-height: 20px;
        margin-top: 25px;
      }
      span {
        display: inline-block;
        width: 48px;
        height: 48px;
        line-height: 48px;
        border-radius: 50%;
        background: #409eff;
        color: #fff;
        font-size: 22px;
      }
    }
  }
  .dialog-title {
    font-weight: bold;
    font-size: 26px;
    margin-top: 0;
    margin-bottom: 0;
    line-height: 0;
  }
}
</style>
